module.exports = __webpack_public_path__ + "static/assets/4ec0744851877cce0c0dd03aa7ca19a6.png";